import React, { Component } from "react";
import "./Contact.css";
import emailjs from "emailjs-com";
import LightSpeed from "react-reveal/LightSpeed";
import styled from "styled-components";
import ReCAPTCHA from "react-google-recaptcha";
import { Map, Marker, GoogleApiWrapper } from "google-maps-react";
import Fade from "react-reveal/Fade";

import n from "./img/phone.png";
import tttt from "./img2/whatsapp.png";
import possibiWhoarewe from "./assets/1259.png";


const MapContainer = styled.div`

max-width:1200px;

width:100%;

height:450px;

margin:0 auto;

position:relative;

overflow:hidden;

border-radius:35px;

border:1px solid rgba(255,255,255,.2);

box-shadow:
0 40px 100px rgba(0,0,0,.5);


& > div{

width:100% !important;

height:100% !important;

}


.gm-style{

width:100% !important;

height:100% !important;

}



@media(max-width:768px){

height:350px;

border-radius:25px;

}


@media(max-width:480px){

height:300px;

border-radius:20px;

}


`;


const Wrapper = styled.section`

direction:rtl;

min-height:700px;

padding:80px 20px;

background:
radial-gradient(circle at top right,#2563eb,transparent 35%),
radial-gradient(circle at bottom left,#7c3aed,transparent 35%),
linear-gradient(135deg,#071426,#0f2747);


`;


const FormCenter = styled.div`

width:100%;

display:flex;

justify-content:center;

align-items:center;

margin-bottom:70px;

`;











const ContactBox = styled.form`

width:100%;
max-width:650px;

background:rgba(255,255,255,.12);

backdrop-filter:blur(25px);

border:1px solid rgba(255,255,255,.2);

padding:45px;

border-radius:35px;

box-shadow:
0 30px 80px rgba(0,0,0,.35);


@media(max-width:600px){
padding:25px;
}

`;

const Title = styled.h2`

text-align:center;

font-size:36px;

font-weight:900;

margin-bottom:30px;

background:
linear-gradient(90deg,#60a5fa,#c084fc);

-webkit-background-clip:text;
-webkit-text-fill-color:transparent;

`;


const Input = styled.input`

width:100%;

padding:18px;

margin-top:18px;

border-radius:18px;

border:none;

outline:none;

font-size:17px;

background:white;

transition:.3s;


&:focus{

box-shadow:
0 0 0 3px rgba(37,99,235,.3);

}


`;


const TextArea = styled.textarea`

width:100%;

padding:18px;

margin-top:18px;

border-radius:18px;

border:none;

outline:none;

font-size:17px;

resize:none;


`;


const Cards = styled.div`

max-width:1200px;

margin:80px auto 0;

display:grid;

grid-template-columns:
repeat(4,1fr);

gap:35px;

align-items:stretch;


@media(max-width:1100px){

grid-template-columns:
repeat(2,1fr);

}


@media(max-width:600px){

grid-template-columns:1fr;

}





`;


const Card = styled.div`

position:relative;

overflow:hidden;


height:520px;

display:flex;

flex-direction:column;

align-items:center;


padding:50px 35px;


border-radius:40px;



background:

linear-gradient(
145deg,
rgba(255,255,255,.22),
rgba(255,255,255,.06)
);



backdrop-filter:blur(30px);

-webkit-backdrop-filter:blur(30px);



border:1px solid rgba(255,255,255,.35);



box-shadow:

0 25px 80px rgba(0,0,0,.35),

inset 0 0 30px rgba(255,255,255,.05);




text-align:center;


transition:

transform .5s ease,

box-shadow .5s ease;



cursor:pointer;




&:hover{

transform:

translateY(-15px)

scale(1.03);



box-shadow:

0 40px 100px rgba(37,99,235,.45),

0 0 50px rgba(124,58,237,.25);


}




&::before{

content:"";

position:absolute;

top:0;

left:0;


width:100%;


height:7px;



background:

linear-gradient(
90deg,
#00c6ff,
#7c3aed,
#2563eb
);


}




&::after{

content:"";

position:absolute;
    pointer-events:none;


width:220px;

height:220px;



background:

radial-gradient(
circle,
rgba(96,165,250,.8),
transparent 70%
);



filter:blur(40px);



bottom:-100px;

right:-100px;



opacity:.5;



transition:.5s;


}




&:hover::after{

transform:scale(1.5);

opacity:.8;


}




.icon{

position:relative;

z-index:2;


width:100px;

height:100px;



margin:0 auto 30px;



display:flex;

align-items:center;

justify-content:center;



border-radius:50%;



font-size:50px;



flex-shrink:0;



background:

linear-gradient(
145deg,
rgba(255,255,255,.35),
rgba(255,255,255,.1)
);




box-shadow:

0 20px 50px rgba(0,0,0,.35),

inset 0 0 20px rgba(255,255,255,.3);




transition:.5s;



}




&:hover .icon{

transform:

rotate(8deg)

scale(1.15);



box-shadow:

0 0 40px rgba(96,165,250,.8);



}





h2{

position:relative;

z-index:2;



font-size:24px;

font-weight:900;



margin-bottom:20px;



color:white;



height:55px;



}




p{

position:relative;

z-index:2;



color:#e0e7ff;



font-size:18px;



line-height:1.9;



font-weight:500;



min-height:140px;



margin:0;



}




a{

margin-top:auto;

}




@media(max-width:600px){

height:auto;

min-height:500px;


}


.statusBox{

margin-top:auto;

position:relative;

z-index:5;

width:100%;

display:flex;

justify-content:center;

}

`;
const Button = styled.a`

position:relative;

z-index:10;


display:inline-flex;

justify-content:center;

align-items:center;


margin-top:25px;


padding:14px 35px;


border-radius:50px;


background:
linear-gradient(
135deg,
#2563eb,
#7c3aed
);


color:white;


font-size:17px;

font-weight:800;


text-decoration:none;


cursor:pointer;


box-shadow:

0 15px 35px rgba(37,99,235,.45);



transition:.35s;



&:hover{

transform:scale(1.08);

box-shadow:

0 20px 50px rgba(124,58,237,.6);


color:white;

}


`;
const Status = styled.div`

padding:10px 18px;

border-radius:50px;


font-size:13px;

font-weight:800;


white-space:nowrap;


background:${props =>
props.open
?
"rgba(34,197,94,.18)"
:
"rgba(239,68,68,.18)"
};



color:${props =>
props.open
?
"#4ade80"
:
"#fca5a5"
};



border:

1px solid ${props =>
props.open
?
"rgba(74,222,128,.5)"
:
"rgba(248,113,113,.5)"
};



box-shadow:

0 8px 25px rgba(0,0,0,.2);



animation:${props =>
props.open
?
"pulse 2s infinite"
:
"none"
};



@keyframes pulse{

0%{

box-shadow:0 0 0 0 rgba(74,222,128,.5);

}

70%{

box-shadow:0 0 0 12px rgba(74,222,128,0);

}

100%{

box-shadow:0 0 0 0 rgba(74,222,128,0);

}

}


`;

const getBusinessStatus = () => {

const now = new Date();

const day = now.getDay();

const hour = now.getHours();

const minute = now.getMinutes();


const current = hour * 60 + minute;


const openTime = 9 * 60 + 30;

const closeTime = 19 * 60;



if(day >= 0 && day <= 4){

if(current >= openTime && current < closeTime){

const remaining = closeTime - current;

const h = Math.floor(remaining / 60);

const m = remaining % 60;


return {
open:true,
text:`פתוח עכשיו • נסגר בעוד ${h} שעות ו-${m} דקות`
};

}


if(current < openTime){

const remaining = openTime - current;

const h = Math.floor(remaining / 60);

const m = remaining % 60;


return {
open:false,
text:`סגור • נפתח בעוד ${h} שעות ו-${m} דקות`
};

}


return {

open:false,

text:"סגור • נפתח מחר בשעה 09:30"

};


}


return {

open:false,

text:"סגור • נפתח ביום ראשון בשעה 09:30"

};


};




 class Contact extends Component {


constructor(props){

super(props);

this.state={

captchaToken:null,

loading:false

};


this.captchaRef=React.createRef();

}



handleonChange=(value)=>{

this.setState({

captchaToken:value

});

}



sendEmail=(e)=>{

e.preventDefault();


if(this.state.loading)
return;


if(!this.state.captchaToken){

alert("יש לאשר שאינך רובוט");

return;

}


this.setState({

loading:true

});


emailjs.sendForm(

"service_b9gmcqa",

"template_hv6pk2g",

e.currentTarget,

"JWHOQYzsIcnM9KDko"


)

.then(()=>{


alert("הודעה נשלחה בהצלחה , ניצור קשר בהקדם ");


e.target.reset();


this.setState({

loading:false,

captchaToken:null

});


this.captchaRef.current.reset();



})


.catch(()=>{


alert("אירעה שגיאה בשליחה , נסה שנית");


this.setState({

loading:false

});


});

}



render(){

const businessStatus = getBusinessStatus();
return (

<Wrapper>


<div>


<img 
src={possibiWhoarewe}
alt="contact"
style={{
width:"220px",
display:"block",
margin:"0 auto 30px"
}}
/>





<LightSpeed right>

<FormCenter>

<ContactBox onSubmit={this.sendEmail}>


<Title>

השאירו פרטים ונחזור אליכם

</Title>


<Input

name="name"

placeholder="שם מלא"

required

/>


<Input

name="tel"

placeholder="טלפון"

/>


<TextArea

name="message"

placeholder="איך נוכל לעזור?"

rows="6"

required

/>




<div
style={{
display:"flex",
justifyContent:"center",
marginTop:25
}}
>


<ReCAPTCHA

ref={this.captchaRef}

sitekey="6LdxKdUdAAAAAGOyVnl1Fs8_GimLD8I8ELh4KDhW"

onChange={this.handleonChange}

/>


</div>




<button

disabled={
this.state.loading ||
!this.state.captchaToken
}

style={{

marginTop:30,

width:"100%",

padding:"16px",

borderRadius:50,

border:"none",

fontSize:20,

fontWeight:"bold",

color:"white",

cursor:"pointer",

background:
"linear-gradient(90deg,#2563eb,#7c3aed)",

opacity:
this.state.loading ||
!this.state.captchaToken
? .5:1

}}

>


{
this.state.loading
?
"שולח..."
:
"שליחת הודעה "
}


</button>



</ContactBox>

</FormCenter>

</LightSpeed>


<Fade top>


<MapContainer>


<Map

google={this.props.google}

zoom={15}


fullscreenControl={true}

zoomControl={true}

streetViewControl={true}



initialCenter={{

lat:32.084890,

lng:34.800629

}}



>


<Marker

position={{

lat:32.084890,

lng:34.800629

}}

title="רחוב שוהם 5, רמת גן"

/>



</Map>


</MapContainer>


</Fade>






<Cards>



<Card>

<div className="icon">
📞
</div>

<h2>
טלפון
</h2>

<p>
050-6831839
</p>

<Button href="tel:0506831839">
התקשר עכשיו
</Button>

</Card>



<Card>

<div className="icon">
📧
</div>

<h2>
אימייל
</h2>

<p>
haivaizman87@gmail.com
</p>
<Button
  href="https://mail.google.com/mail/?view=cm&fs=1&to=haivaizman87@gmail.com"
  target="_blank"
  rel="noopener noreferrer"
>
  שלח מייל
</Button>

</Card>




<Card>

<div className="icon">
📍
</div>

<h2>
המשרד שלנו
</h2>

<p>
רחוב שוהם 5
<br/>
רמת גן
</p>
<Button
  href="https://waze.com/ul?q=רחוב%20שוהם%205,%20רמת%20גן&navigate=yes"
  target="_blank"
  rel="noopener noreferrer"
>
  ניווט ב-Waze
</Button>

</Card>

<Card>

<div className="icon">
🕒
</div>


<h2>
שעות פעילות
</h2>


<p>

ראשון - חמישי

<br/>

09:30 - 19:00

<br/><br/>



</p>



<div className="statusBox">

<Status open={businessStatus.open}>

<span className="dot">
●
</span>

{businessStatus.text}


</Status>

</div>



</Card>




</Cards>













</div>


</Wrapper>

);


}


}


export default GoogleApiWrapper({

apiKey:"AIzaSyC2H55uGYHc55B2L3CwQd2Jzijoj_isaU0",

language:"he",

region:"IL"

})(Contact);